export default "__VITE_ASSET__BOyewTdy__"